import {
  gql
} from "@apollo/client";

export const ADD_CLAIM_WARRANTY = gql`
    mutation addClaimWarranty(
        $email: String!
        $number: String!
        $firstname: String!
        $lastname: String!
        $issues: String!
        $imgs: [String]!
    ) {
        addClaimWarranty(
            input: {
                email: $email
                number: $number
                firstname: $firstname
                lastname: $lastname
                issues: $issues
                imgs: $imgs
            }
        ) {
            code
            message
            content
        }
    }
`;

export default {
  addClaimWarrantyMutation: ADD_CLAIM_WARRANTY
};
